import { Component, inject, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { LANGUAGE_NAMES } from '@core/constants/language';
import { isSupportedLanguage, Language } from '@core/enums/language';
import { Storage } from '@core/services/storage';
import { environment } from '@environments/environment';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { HyphenatePipe } from '@shared/pipes/hyphenate-pipe';
import { navigateToLocationWithLang, withLanguageParam } from '@utils/location';
import { getActiveLanguage } from '@utils/translate';

@Component({
  selector: 'app-main-navigation-mobile',
  templateUrl: './main-navigation-mobile.html',
  styleUrl: './main-navigation-mobile.scss',
  imports: [CommonModule, RouterLink, MatMenuModule, TranslatePipe, HyphenatePipe]
})
export class MainNavigationMobile {
  private translateService = inject(TranslateService);
  private storageService = inject(Storage);

  protected loginUrl: string;
  protected selectedLang: Language;
  protected languages = LANGUAGE_NAMES;

  public readonly expanded = model<boolean>(false);

  constructor() {
    this.selectedLang = getActiveLanguage(this.translateService) as Language;
    this.loginUrl = withLanguageParam(environment.loginUrl, this.selectedLang);
  }

  expand() {
    this.expanded.set(true);
  }

  collapse() {
    this.expanded.set(false);
  }

  navigate() {
    this.expanded.set(false);
  }

  onChangeLang(languageCode: string) {
    if (!isSupportedLanguage(languageCode)) {
      return;
    }

    this.storageService.setLanguage(languageCode);
    navigateToLocationWithLang(languageCode);
  }
}
